import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { useDispatch, useSelector } from "react-redux";
import { setOrgSettings } from "@redux/slices/orgSettingsSlice";
import { setAppState } from "@redux/slices/appStateSlice";
import { ProductCategory } from "@utils/constants";
import Constants from "expo-constants";

export const useOrgSettings = (platform: number) => {
  const dispatch = useDispatch();
  const activeProductType = useSelector(
    (state: any) => state.appState?.activeProduct
  );
  const requestScreenColor = useSelector(
    (state: any) => state.appState?.requestScreenColor
  );
  return useQuery({
    queryKey: ["ORG_SETTINGS"],
    cacheTime: 0,
    staleTime: 0,
    queryFn: () =>
      apiClient
        .get(Routes.ORG_SETTINGS, {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
          params: {
            platform,
            config_version: process.env.EXPO_PUBLIC_APP_CONFIG_VERSION
              ? process.env.EXPO_PUBLIC_APP_CONFIG_VERSION
              : Constants?.expoConfig?.extra?.appConfigVersion,
          },
        })
        .then((data) => {
          dispatch(setOrgSettings(data.data));
          dispatch(
            setAppState({
              isCustomApp: !(
                data.data?.organization?.id === 1 ||
                data.data?.organization?.id === 89
              ),
              logo:
                data?.data?.main_logo_url ||
                data?.data?.logo_url ||
                process.env.EXPO_PUBLIC_LOGIN_LOGO,
              activeProduct: activeProductType
                ? activeProductType
                : ProductCategory.DEFAULT,
              requestScreenColor: requestScreenColor
                ? requestScreenColor
                : ProductCategory.DEFAULT,
            })
          );
          return data;
        }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
